
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftLeft100 as ObiThreewayStackedInleftLeft100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-left-100.js';
 
 
 

 
 export const ObiThreewayStackedInleftLeft100 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-left-100',
   elementClass: ObiThreewayStackedInleftLeft100Element,
   events: {
     
   }
  });
 
 